import React, { Children, useEffect } from 'react'
import { Row, Column } from 'simple-flexbox'
import { createUseStyles, useTheme } from 'react-jss';
import HeaderComponent from './header/HeaderComponent'
import { SidebarComponent, SidebarContext } from './sidebar'
import { useLocation, useNavigate } from 'react-router';
import { clearLocal, getQueryParams, setLocalStoreString } from '../../utils/Helper';
import { useDispatch } from 'react-redux'
import { IS_IOS_DEVICE, QUERY_EMPLOYEE_DETAILS } from '../../sagas/type';

const useStyles = createUseStyles({
    container: {
        height: '100%',
        // minHeight: 850
    },
    mainBlock: {
        marginLeft: 185,
        '@media (max-width: 1080px)': {
            marginLeft: 0
        },
        backgroundColor: '#0E204A',
    },
});

function Layout({ ...props }) {
    const { title, isNoneHeader, children, privateRoute, publicRoute } = props
    const BearerToken = localStorage.getItem("BearerToken");
    const LoggedIn = localStorage.getItem('LoggedIn')
    const navigate = useNavigate();
    const location = useLocation()
    const theme = useTheme();
    const classes = useStyles({ theme });
    const dispatch = useDispatch()

    const getEmployeeDetails = (paramsToken) => {
        const paramToken = { Token: paramsToken }
        dispatch({
            type: QUERY_EMPLOYEE_DETAILS,
            payload: paramToken,
        });
    }

    const updateToken = (token) => {
        localStorage.setItem("BearerToken", token)
    }
    const updatePlatForm = (platform) => {
        setLocalStoreString("platform", platform)
        dispatch({
            type: IS_IOS_DEVICE,
            payload: platform,
        })
    }

    const handleRoute = () => {
        const paramsToken = getQueryParams(location, "token");
        const paramsPlatform = getQueryParams(location, "platform");
        if (privateRoute && !BearerToken && !paramsToken) {
            navigate("/")
        }
        if (paramsToken) {
            clearLocal()
            updateToken(paramsToken)
            updatePlatForm(paramsPlatform)
            getEmployeeDetails(paramsToken);
        }
    }

    useEffect(() => {
        handleRoute()
    }, [privateRoute, publicRoute])

    return (
        <SidebarContext>
            <Row className={classes.container}>
                {LoggedIn == 'true' && <SidebarComponent />}
                <Column flexGrow={1} className={classes.mainBlock}>
                    {
                        !props || props && (!isNoneHeader) && LoggedIn == 'true' && (
                            <HeaderComponent title={title} />
                        )}
                    <div className={classes.contentBlock}>
                        {children}
                    </div>
                </Column>
            </Row>
        </SidebarContext>
    )
}

export default Layout